import { FC } from 'react';
import SharedModal from '../../../../../../ui/modal/shared-modal';
import classNames from '../../../../../../utils/classnames';
import SuccessIcon from '../../../../../../images/success-icon.svg';
import translation from '../../../../../../languages';
import './android-success-modal.scss';

type AndroidSuccessModalProps = TranslationProps & {
    deeplink: string;
};

const AndroidSuccessModal: FC<AndroidSuccessModalProps> = ({ deeplink, t }) => {
    const defaultBtnConfig = [
        {
            action: () => {
                window.location.href = deeplink;
            },
            className: 'styled yellow',
            text: t('payment.androidSuccessModal.button')
        }
    ];

    const modalBody = () => {
        return (
            <div className='text-center'>
                <p>
                    <img src={SuccessIcon} height={80} alt='' />
                </p>
                <p className='tsc-h4'>{t('payment.androidSuccessModal.title')}</p>
                <div className='tsc-body'>{t('payment.androidSuccessModal.body')}</div>
            </div>
        );
    };

    return (
        <SharedModal
            dialogClassName={classNames('android-success-modal')}
            onClose={() => {}}
            closeButton={false}
            body={modalBody()}
            btnConfig={defaultBtnConfig}
            title={<></>}
        />
    );
};

const translate = translation('payment');

export default translate(AndroidSuccessModal);
